export default __webpack_public_path__ + "static/media/val1.518a2bc6.png";